import { Injectable } from "@angular/core";
import { HttpService } from "../../utils/services/http.service";
import { Observable } from "rxjs/Observable";
import { ErrorsService } from "../../utils/services/errors.service";

@Injectable()
export class EditTimesheetService {
  constructor(
    private httpService: HttpService,
    private errorsService: ErrorsService
  ) {}

  /*Get the employee list from the Backend */
  getEmployeesDetails(status, search): Observable<any> {
    const data = {
      searchText: search,
      status: status,
    };
    return this.httpService
      .post(`employee/listFilter`, data)
      .map((res: Response) => res.json())
      .catch((error: any) => {
        return this.handleError(error);
      });
  }

  /*API to enable the timesheet for particular employee */
  enableTimesheet(data): Observable<any> {
    return this.httpService
      .post(`report/enableTimesheet`, data)
      .map((res: Response) => res.json())
      .catch((error: any) => {
        return this.handleError(error);
      });
  }

  /*Handle error service*/
  handleError(error: any) {
    this.errorsService.handleError(error);
    return Observable.throw(error.json());
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/edit-timesheet/edit-timesheet.service.ts